import React from 'react';
import PageTemplate from '../PageTemplate';

const SmartphoneFree = () => {
  return (
    <PageTemplate
      title="📱 스마트폰프리운동"
      description="청소년의 건강한 성장을 위한 스마트폰프리운동을 소개합니다"
    >
      <div>
        {/* 문제점 섹션 */}
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            스마트폰 과의존 문제
          </h2>
          <div style={{ 
            display: 'grid', 
            gap: '1.5rem',
            color: '#444',
            lineHeight: '1.8'
          }}>
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>🔍 현황</h3>
              <p>
                스마트폰은 현대 생활의 필수품이 되었지만, 과도한 사용으로 인한 부작용이 심각한 사회문제로 대두되고 있습니다.
                특히 성장기 청소년들의 스마트폰 과의존은 신체적, 정신적 발달에 부정적 영향을 미치고 있습니다.
              </p>
            </div>
            
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>⚠️ 주요 문제점</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>학습 능력 저하 및 집중력 감소</li>
                <li>수면 부족과 신체 발달 저해</li>
                <li>대인관계 및 사회성 발달 저해</li>
                <li>디지털 콘텐츠 과몰입과 중독</li>
                <li>사이버폭력 및 유해정보 노출 위험</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 운동의 필요성 섹션 */}
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            스마트폰프리운동의 필요성
          </h2>
          <div style={{ 
            display: 'grid', 
            gap: '1.5rem',
            color: '#444',
            lineHeight: '1.8'
          }}>
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>🎯 목적</h3>
              <p>
                스마트폰프리운동은 스마트폰 사용을 완전히 금지하는 것이 아닌, 
                청소년들이 스마트폰과 건강한 관계를 맺고 올바르게 활용할 수 있도록 돕는 것을 목적으로 합니다.
              </p>
            </div>
            
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>💡 주요 가치</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>자기주도적 디지털 활용 능력 향상</li>
                <li>건강한 성장과 발달 지원</li>
                <li>창의적이고 능동적인 여가 활동 장려</li>
                <li>가족 및 또래와의 관계 증진</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 기대효과 섹션 */}
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            기대효과
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '1.5rem'
          }}>
            <div style={{
              background: '#fff',
              border: '2px solid #e74c3c',
              borderRadius: '12px',
              padding: '1.5rem',
              textAlign: 'center'
            }}>
              <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>🧠 인지적 측면</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                집중력과 학습능력 향상<br />
                창의적 사고력 발달<br />
                자기주도적 학습 능력 증진
              </p>
            </div>

            <div style={{
              background: '#fff',
              border: '2px solid #e74c3c',
              borderRadius: '12px',
              padding: '1.5rem',
              textAlign: 'center'
            }}>
              <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>💪 신체적 측면</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                수면의 질 개선<br />
                신체 활동량 증가<br />
                디지털 기기 관련 질환 예방
              </p>
            </div>

            <div style={{
              background: '#fff',
              border: '2px solid #e74c3c',
              borderRadius: '12px',
              padding: '1.5rem',
              textAlign: 'center'
            }}>
              <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>🤝 사회적 측면</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                대면 소통 능력 향상<br />
                가족 관계 증진<br />
                또래 관계 개선
              </p>
            </div>
          </div>
        </section>

        {/* 해외 사례 섹션 */}
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            해외 사례
          </h2>
          <div style={{ 
            display: 'grid', 
            gap: '1.5rem',
            color: '#444',
            lineHeight: '1.8'
          }}>
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>🌏 주요 국가별 정책</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li><strong>프랑스:</strong> 초중등학교 내 스마트폰 사용 제한 법제화</li>
                <li><strong>미국:</strong> 디지털 웰빙 교육 프로그램 운영</li>
                <li><strong>일본:</strong> 청소년 스마트폰 사용 가이드라인 제정</li>
                <li><strong>독일:</strong> 미디어 리터러시 교육 의무화</li>
              </ul>
            </div>
            
            <div>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>📚 성공 사례</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>학교-가정-지역사회 연계 프로그램 운영</li>
                <li>청소년 주도 디지털 디톡스 캠페인</li>
                <li>대안 활동 프로그램 개발 및 보급</li>
                <li>부모 교육 및 가족 참여 프로그램</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 실천 방안 */}
        <section>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            실천 방안
          </h2>
          <div style={{
            background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
            color: 'white',
            padding: '2rem',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <h3 style={{ marginBottom: '1.5rem', fontSize: '1.2rem' }}>
              함께 만들어가는 건강한 디지털 문화
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '1.5rem',
              textAlign: 'left',
              marginBottom: '1.5rem'
            }}>
              <div>
                <h4 style={{ marginBottom: '0.5rem' }}>👨‍👩‍👧‍👦 가정에서</h4>
                <ul style={{ paddingLeft: '1.2rem', fontSize: '0.9rem' }}>
                  <li>스마트폰 사용 규칙 함께 정하기</li>
                  <li>대화 시간 늘리기</li>
                  <li>가족 활동 계획하기</li>
                </ul>
              </div>
              <div>
                <h4 style={{ marginBottom: '0.5rem' }}>🏫 학교에서</h4>
                <ul style={{ paddingLeft: '1.2rem', fontSize: '0.9rem' }}>
                  <li>디지털 시민교육 참여</li>
                  <li>창의적 활동 참여</li>
                  <li>또래 활동 증진</li>
                </ul>
              </div>
              <div>
                <h4 style={{ marginBottom: '0.5rem' }}>🏃‍♂️ 개인적으로</h4>
                <ul style={{ paddingLeft: '1.2rem', fontSize: '0.9rem' }}>
                  <li>사용 시간 모니터링</li>
                  <li>취미 활동 개발</li>
                  <li>운동 습관 기르기</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageTemplate>
  );
};

export default SmartphoneFree; 